export default "__VITE_ASSET__euhGMWYQ__"